import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
// Slice
import { setActiveLoginModal, setLms } from '../../app/features/userSlice';
// Components
import Container from '../Container';
// Services
import { autenticationURL } from '../../services/Login/getInstitutionData';
// Images
import { IoMdClose } from 'react-icons/io';
import imageLogin from '../../Images/Login/ImageModal.webp';
// Images
import logoHeaderHome from '../../Images/logo/logo_OlibBlack.svg';
import AquinoImage from '../../Images/Login/Modal/Aquino.png';
import iconModal from '../../Images/Login/Modal/IconModal.svg';
import CanvasLogo from '../../Images/canvas_logo.png';
import WordpressLogo from '../../Images/login-wordpress.png';
import MoodleLogo from '../../Images/moodle-logo.webp';
import TalentLMSLogo from '../../Images/talent-lms-logo.png';
import DigitalOceanLogo from '../../Images/digital-ocean-logo.png';
import AquinoLogo from '../../Images/aquino-bottom2.png';
import BlackboardLogo from '../../Images/blackboard-logo.jpeg';
import D2lLogo from '../../Images/d2l-logo.png';
import GoogleLogo from '../../Images/google-icon.webp';

// Styles
import './LoginModal.css';
// Translate
import { useTranslation } from 'react-i18next';
import { libraryStates } from '../../utils/libraryStates';

const LoginModal = () => {
	const { t } = useTranslation();
	const navigate = useNavigate();

	const dispatch = useDispatch();
	const {
		institutionCode,
		assignedLogin,
		isActive,
		institutionState,
		googleAuthConfig,
	} = useSelector((state) => state.institution);

	const normalizeProvider = (provider = '') =>
		provider.toString().trim().toLowerCase();

	const loginButtonName = (name) => {
		const provider = normalizeProvider(name);
		const isUnique = provider === 'unique';

		if (provider === 'google') {
			return `${t('Login with')} Google`;
		}

		if (provider === 'kajabi') {
			return `${t('Login with')} Kajabi`;
		}

		const baseName = isUnique
			? institutionCode === 'CMVC'
				? `${t('Login with')} moodle`
				: t('Unique login')
			: `${t('Login with')} ${provider}`;
		return baseName;
	};

	const getLogin = (login) => {
		const provider = normalizeProvider(login);
		dispatch(setActiveLoginModal(false));
		if (provider === 'unique' || provider === 'talent') {
			navigate('login');
		} else if (provider === 'canvas' || provider === 'moodle') {
			dispatch(setLms(provider));
			window.location.href = autenticationURL(provider, institutionCode);
		} else if (provider === 'moodle 2.9') {
			dispatch(setLms('moodle 2.9'));
			window.location.href = autenticationURL(provider, `${institutionCode}_2`);
		} else if (provider === 'digitalocean') {
			dispatch(setLms(provider));
			window.location.href = autenticationURL(provider, institutionCode);
		} else if (provider === 'blackboard') {
			dispatch(setLms(provider));
			window.location.href = autenticationURL(provider, institutionCode);
		} else if (provider === 'populi') {
			dispatch(setLms(provider));
			window.location.href = autenticationURL(provider, institutionCode);
		} else if (provider === 'd2l' || provider === 'brightspace') {
			dispatch(setLms(provider));
			window.location.href = autenticationURL(provider, institutionCode);
		} else if (provider === 'google') {
			dispatch(setLms(provider));
			const authUrl = autenticationURL(
				provider,
				institutionCode,
				googleAuthConfig,
			);
			if (authUrl) {
				window.location.href = authUrl;
				return;
			}

			console.error(
				`Google auth config is missing for institution: ${institutionCode}`,
			);
		} else if (provider === 'kajabi') {
			dispatch(setLms(provider));
			const authUrl = autenticationURL(provider, institutionCode);
			if (authUrl) {
				window.location.href = authUrl;
				return;
			}

			console.error(
				`Kajabi auth config is missing for institution: ${institutionCode}`,
			);
		} else if (provider === 'wordpress') {
			navigate('login-with-wordpress');
		}
	};

	const formatProviders = (providers) => {
		if (!providers || providers.length === 0) return '';

			const labels = providers.map((provider) => {
				const normalizedProvider = normalizeProvider(provider);
				if (normalizedProvider === 'unique') return 'unique login';
				if (normalizedProvider === 'google') return 'Google';
				if (normalizedProvider === 'kajabi') return 'Kajabi';
				return normalizedProvider;
			});

		if (labels.length === 1) return labels[0];
		if (labels.length === 2) return `${labels[0]} or ${labels[1]}`;

		return `${labels.slice(0, -1).join(', ')}, or ${labels.at(-1)}`;
	};

	const isCancelledState = institutionState === libraryStates.CANCELLED;
	const isDemoCancelledState =
		institutionState === libraryStates.DEMO_CANCELLED;
	const isDuplicateState = institutionState === libraryStates.DUPLICATE;

	const hasPriorityState =
		isCancelledState || isDemoCancelledState || isDuplicateState;

	const showLoginContent = isActive && !hasPriorityState;
	const showDefaultInactiveContent = !isActive && !hasPriorityState;
	const isSpecialState =
		institutionState === libraryStates.CANCELLED ||
		institutionState === libraryStates.DEMO_CANCELLED ||
		institutionState === libraryStates.DUPLICATE;

	return (
		<div className='loginHomeModal'>
			<Container>
				<div
					// className={isActive ? 'modal-content' : 'modal-content Deactivate'}
					className={`modal-content ${!isActive || isSpecialState ? 'Deactivate' : ''}`}
				>
					<button
						className='closeButton'
						onClick={() => dispatch(setActiveLoginModal(false))}
					>
						<IoMdClose />
					</button>

					{showLoginContent && (
						<>
							<div className='imageContent'>
								<img src={imageLogin} alt='Modal login' />
								<div className='imageText'>
									<p>
										Your Unified Portal to <b>Aquinas Online Library</b>
									</p>
									<p>
										Find books, scholarly articles, and exclusive resources by
										exploring hundreds of library databases worldwide. <br />
										Thanks to our built-in artificial intelligence, perform
										faster, more accurate searches tailored to your needs
									</p>
								</div>
							</div>

							<div className='textContent'>
								<img src={logoHeaderHome} alt='logo Aquinas' />
								<div className='flex justify-center max-w-[300px] lg:max-w-[450px]'>
									<p className='text-center text-lg font-light lg:text-2xl'>
										Log in to the library using your{' '}
										<b className='font-semibold'>
											{formatProviders(assignedLogin)} account credentials.
										</b>
									</p>
								</div>

								<div className='loginButtonModalContainer flex flex-wrap gap-2'>
									{assignedLogin?.map((login, i) => {
										const provider = normalizeProvider(login);
										return (
											<button
												onClick={() => getLogin(login)}
												key={`${login}-${i}`}
												className='bg-green-aquinas rounded-full px-4 py-2 flex items-center gap-x-4 justify-center text-white hover:scale-105 transition-all duration-300'
											>
												{loginButtonName(login)}

												{provider === 'canvas' && (
													<div className='flex items-center justify-center bg-[#c9ede0] p-2 rounded-full'>
														<img
															src={CanvasLogo}
															alt='logo Aquinas'
															className='w-full max-h-[25px] max-w-[25px]'
														/>
													</div>
												)}

												{provider === 'wordpress' && (
													<div className='flex items-center justify-center bg-[#c9ede0] p-2 rounded-full'>
														<img
															src={WordpressLogo}
															alt='logo Aquinas'
															className='w-full max-h-[25px] max-w-[25px] invert'
														/>
													</div>
												)}

												{(provider === 'd2l' || provider === 'brightspace') && (
													<div className='flex items-center justify-center bg-[#c9ede0] p-2 rounded-full'>
														<img
															src={D2lLogo}
															alt='logo Aquinas'
															className='w-full max-h-[25px] max-w-[25px]'
														/>
													</div>
												)}

												{(provider === 'moodle' ||
													provider === 'moodle 2.9') && (
													<div className='flex items-center justify-center bg-[#c9ede0] p-2 rounded-full'>
														<img
															src={MoodleLogo}
															alt='logo Aquinas'
															className='w-full max-h-[25px] max-w-[25px]'
														/>
													</div>
												)}

												{provider === 'talent' && (
													<div className='flex items-center justify-center bg-[#c9ede0] p-2 rounded-full'>
														<img
															src={TalentLMSLogo}
															alt='logo Aquinas'
															className='w-full max-h-[25px] max-w-[25px]'
														/>
													</div>
												)}

												{provider === 'digitalocean' && (
													<div className='flex items-center justify-center bg-[#c9ede0] p-2 rounded-full'>
														<img
															src={DigitalOceanLogo}
															alt='logo Aquinas'
															className='w-full max-h-[25px] max-w-[25px]'
														/>
													</div>
												)}

												{provider === 'blackboard' && (
													<div className='flex items-center justify-center bg-[#c9ede0] p-2 rounded-full'>
														<img
															src={BlackboardLogo}
															alt='logo Aquinas'
															className='w-full max-h-[25px] max-w-[25px]'
														/>
													</div>
												)}

												{provider === 'google' && (
													<div className='flex items-center justify-center bg-[#c9ede0] p-2 rounded-full'>
														<img
															src={GoogleLogo}
															alt='logo Aquinas'
															className='w-full max-h-[25px] max-w-[25px]'
														/>
													</div>
												)}

												{provider === 'unique' && (
													<div className='flex items-center justify-center bg-[#c9ede0] p-2 rounded-full'>
														<img
															src={AquinoLogo}
															alt='logo Aquinas'
															className='w-full max-h-[25px] max-w-[22px]'
														/>
													</div>
												)}
											</button>
										);
									})}
								</div>
							</div>
						</>
					)}

					{showDefaultInactiveContent && (
						<div>
							<div className='noActiveContent'>
								<img src={AquinoImage} alt='logo Aquinas' />
								<div className='info'>
									<img src={iconModal} alt='icon' />
									<p>We want to see you back</p>
								</div>
							</div>
							<p className='infoText'>
								We just wanted to remind you that{' '}
								<b>your subscription has expired</b>. It was a pleasure having
								you during this time. If you enjoyed your experience, please
								renew your subscription and continue enjoying all the benefits
								of our bookstore. We look forward to seeing you again!
							</p>
						</div>
					)}

					{isCancelledState && (
						<div>
							<div className='noActiveContent'>
								<img src={AquinoImage} alt='logo Aquinas' />
								<div className='info'>
									<img src={iconModal} alt='icon' />
									<p>We want to see you back</p>
								</div>
							</div>
							<p className='infoText'>
								We just wanted to remind you that{' '}
								<b>your subscription has expired</b>. It was a pleasure having
								you during this time. If you enjoyed your experience, please
								renew your subscription and continue enjoying all the benefits
								of our bookstore. We look forward to seeing you again!
							</p>
						</div>
					)}

					{isDemoCancelledState && (
						<div>
							<div className='noActiveContent'>
								<img src={AquinoImage} alt='logo Aquinas' />
								<div className='info'>
									<img src={iconModal} alt='icon' />
									<p>We want to see you back</p>
								</div>
							</div>
							<p className='infoText'>
								Your demo access has expired. To continue using all bookstore
								features, please contact your sale representative.
							</p>
						</div>
					)}

					{isDuplicateState && (
						<div>
							<div className='noActiveContent'>
								<img src={AquinoImage} alt='logo Aquinas' />
								<div className='info'>
									<img src={iconModal} alt='icon' />
									<p>This is a Duplicated Library</p>
								</div>
							</div>
							<p className='infoText'>
								This online library is a duplicate of another one. Please
								contact the administrator of your institution to resolve this
								issue.
							</p>
						</div>
					)}

					{console.log('Institution State', institutionState)}
				</div>
			</Container>
		</div>
	);
};

export default LoginModal;
